<template>
  <div>
    <h1 class="h3 mb-2 text-gray-800">
      {{ $t("Gestão de Localidades (bairro, povoado, vila etc.)") }}
    </h1>

    <b-card class="shadow">
      <div class="row">
        <div class="col-12">
          <div class="row">
            <div
              class="col-12 d-flex align-items-center justify-content-between mb-4"
            >
              <div>
                <router-link
                  class="btn btn-primary"
                  to="/dashboard/enderecos/localidades/add"
                >
                  <i class="fas fa-plus-square" />
                  {{ $t("Cadastrar") }}
                </router-link>

                <b-button
                  :title="$t('Importar Localidades')"
                  @click="importarLocalidades()"
                  class="btn-importar"
                  type="button"
                  v-b-tooltip.hover
                  variant="primary"
                  v-if="$store.state.user.role_details.name == 'Admin'"
                >
                  <i class="fas fa-cloud-upload-alt" />
                  {{ $t("Importar Localidades") }}
                </b-button>
              </div>
              <div>
                <div class="input-group mb-3">
                  <b-input
                    :placeholder="$t('Type to search')"
                    class="form-control search-input"
                    type="text"
                    v-model="search"
                    v-on:change="getLocalidades"
                    aria-describedby="input-search"
                  />
                  <div class="input-group-append" role="button">
                    <span class="input-group-text" id="input-search"
                      ><i class="fas fa-search search-icon"
                    /></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <loading-animation
                :active.sync="loading"
                :is-full-page="false"
                :opacity="1"
                color="#5895FF"
              />
              <b-table
                :fields="[
                  {
                    key: 'nome',
                    label: $t('Nome'),
                  },
                  {
                    key: 'quant_logradouros',
                    label: $t('Qtd. Logradouros'),
                  },
                  {
                    key: 'origem',
                    label: $t('Origem'),
                  },
                  {
                    key: 'data_cadastro',
                    label: $t('Criado em'),
                  },
                  {
                    key: 'actions',
                    label: '',
                    class: 'text-right',
                  },
                ]"
                :items="localidadesList"
                :responsive="true"
                fixed
                striped
                hover
                show-empty
                small
                outlined
                stacked="md"
                table-class="mb-3"
              >
                <template v-slot:cell(nome)="data">
                  {{ data.value }}
                </template>
                <template v-slot:cell(quant_logradouros)="data">
                  {{ data.value }}
                </template>
                <template v-slot:cell(origem)="data">
                  {{ data.value }}
                </template>
                <template v-slot:cell(data_cadastro)="data">
                  {{ data.value }}
                </template>
                <template v-slot:cell()="data">
                  <b-button
                    :title="$t('Edit Localidade')"
                    :to="
                      '/dashboard/enderecos/localidades/edit/' + data.item.id
                    "
                    class="px-2 mb-0"
                    size="xs"
                    type="button"
                    v-b-tooltip.hover
                    variant="success"
                  >
                    <i class="mdi mdi-square-edit-outline" />
                  </b-button>
                </template>
                <template v-slot:empty="scope">
                  <div class="text-center my-5">
                    <img
                      :alt="$t('No results')"
                      class="mb-5"
                      src="/img/icons/robot.svg"
                      style="max-height: 165px"
                    />
                    <h3 class="bold">{{ $t("No records found") }}</h3>
                  </div>
                </template>
                <template v-slot:emptyfiltered="scope">
                  <div class="text-center my-5">
                    <img
                      :alt="$t('No results')"
                      class="mb-5"
                      src="/img/icons/robot.svg"
                      style="max-height: 165px"
                    />
                    <h3>{{ $t("No records match the entered search") }}</h3>
                  </div>
                </template>
              </b-table>

              <div class="row align-items-center">
                <div class="col-lg-6 col-md-12">
                  <div class="form-group d-inline-flex mb-0">
                    <select
                      class="form-control"
                      style="width: 70px"
                      v-model="perPage"
                      v-on:change="getLocalidades"
                    >
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                    </select>
                  </div>
                  <div class="d-inline-flex ml-2">
                    <b-pagination
                      :per-page="perPage"
                      :total-rows="pagination.total"
                      @change="changePage"
                      v-model="page"
                    />
                  </div>
                </div>
                <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
                  <div class="float-lg-right">
                    {{ $t("Showing page") }} {{ pagination.currentPage }}
                    {{ $t("of") }} {{ pagination.totalPages }}
                    {{ $t("pages in") }} {{ pagination.total }}
                    {{ $t("records") }}
                  </div>
                </div>
              </div>
            </div>
            <router-view />
          </div>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "Read",
  metaInfo() {
    return {
      title: this.$i18n.t("Gestão de Localidades"),
    };
  },
  data() {
    return {
      page: 1,
      search: "",
      perPage: 10,
      loading: true,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      localidadesList: [],
    };
  },
  mounted() {
    this.getLocalidades();
  },
  methods: {
    // Change the page
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getLocalidades();
      }
    },
    // Get roles list
    getLocalidades() {
      this.loading = true;
      axios
        .get("api/dashboard/enderecos/localidades", {
          params: {
            page: this.page,
            search: this.search,
            perPage: this.perPage,
          },
        })
        .then((response) => {
          this.localidadesList = response.data.data;
          this.pagination = response.data.pagination;
          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getLocalidades();
          } else {
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    importarLocalidades() {
      let ladda = Ladda.create(document.querySelector(".btn-importar"));
      ladda.start();

      axios
        .post("api/dashboard/enderecos/importar/localidades")
        .then((response) => {
          ladda.stop();
          this.$snack.show({
            button: false,
            text: response.data.data.message,
          });

          ladda.stop();
        });
    },
  },
};
</script>
